module.exports = __webpack_public_path__ + "static/ogundipe-f6296ec4327ec1cabb1e6d173ebc8a5d.png";